import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import {
  Body1Strong as BoldText,
  Caption2 as SmallText,
  Divider,
} from '@fluentui/react-components';

import { DESCRIPTION_STRING } from './consts';
import { useGetStyledAssetStatus } from '../utils/use-get-styled-asset-status';
import { useGetPerformanceTag } from '../utils/use-get-performance-tag';
import { Asset } from '../utils/types';
import { usePopoverStyles } from '../styles/popover-styles';

interface AssetPerformancePopoverProps {
  i18n: any;
  asset: Asset;
}

export function AssetPerformancePopover({ i18n, asset }: AssetPerformancePopoverProps) {
  const styles = usePopoverStyles();
  const getPerformanceTag = useGetPerformanceTag(i18n);
  const getStyledAssetStatus = useGetStyledAssetStatus(i18n);

  return (
    <div className={classNames('asset-perf-card-popover', styles.container)}>
      <div className={styles.title}>
        <BoldText className="title" align="start">{i18n.getString(_TL_('Asset details'))}</BoldText>
      </div>
      <div className={classNames('perf-editorial-row', styles.perfEditorialRow)}>
        {getPerformanceTag(asset)}
        {getStyledAssetStatus(asset)}
      </div>
      <div className={classNames('impressions-row', styles.row)}>
        <p className="impressions-title">{i18n.getString(_TL_('Impressions'))}</p>
        <BoldText className="impressions-value">{_.isNumber(asset.PerformanceMetrics.Impressions) ? asset.PerformanceMetrics.Impressions : '--'}</BoldText>
      </div>
      <div className={classNames('clicks-row', styles.row)}>
        <p className="clicks-title">{i18n.getString(_TL_('Clicks'))}</p>
        <BoldText className="clicks-value">{_.isNumber(asset.PerformanceMetrics.Clicks) ? asset.PerformanceMetrics.Clicks : '--'}</BoldText>
      </div>
      <Divider className="divider" />
      <SmallText className={classNames('description', styles.description)}>{i18n.getString(DESCRIPTION_STRING[asset.PerformanceLabel ?? ''])}</SmallText>
    </div>
  );
}
